module.exports = __webpack_public_path__ + "img/catalog_icon_liveing.99222775.gif";